<template src="./SearchEngine.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Pagination from "@/components/components/pagination"

const { mapGetters, mapActions} = createNamespacedHelpers('sites/googleRegion')

export default {
  name: "GoogleRegion",
  components: {
    Pagination
  },
  data () {
    return {
      showOverlay: false,
      type: 'ru',
      fieldsList: [
        {
          key: 'id',
          label: 'Номер записи',
          sortable: true
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true
        },
        {
          key: 'regionCode',
          label: 'Код региона',
          sortable: true
        },
        {
          key: 'lang',
          label: 'Язык',
          sortable: true
        }
      ],
      currentPage: 1,
      currentSort: 'id',
      currentSortDir: 'asc',
      searchVal: '',
      oldType: 'ru',
      brands: [],
      activeEdit: {
        'index': null,
        'field': null,
      }
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_TYPE',
      'GET_SEARCH_ENGINE',
      'SAVE',
    ]),
    goToPage: function (page) {
      if (this.checkIsChange()) {
        return false
      }
      this.$store.commit('sites/googleRegion/CURRENT_PAGE', page)
      this.GET_DATA({th: this})
    },
    perPage: function (page) {
      if (this.checkIsChange()) {
        return false
      }
      this.$store.commit('sites/googleRegion/CURRENT_PAGE', 1)
      this.$store.commit('sites/googleRegion/PER_PAGE', page)
      this.GET_DATA({th: this})
    },
    initPageSize: function () {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 230) / 26)
      this.$store.commit('sites/googleRegion/PER_PAGE', winHeight)
      this.currentPage = 1
    },
    changeType: function () {
      if (this.checkIsChange()) {
        this.type = this.oldType
        return false
      }
      this.oldType = this.type
      this.GET_DATA({th: this})
    },
    editCell: function (index, field) {
      this.activeEdit.index = index
      this.activeEdit.field = field

      let viewCell = this.$refs.contentTable.$el.querySelectorAll('.t-cell')
      viewCell.forEach((val) => {
        val.style.display = 'block'
      })

      let editCell  = this.$refs.contentTable.$el.querySelectorAll('.edit-cell')
      editCell.forEach((val) => {
        val.style.display = 'none'
      })

      this.$refs['cell_view_' + index +'_'+ field].style.display = 'none'
      if (this.$refs['cell_edit_' + index +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + index +'_'+ field].style.display = 'block'
        this.$refs['cell_edit_' + index +'_'+ field].focus()
      } else {
        this.$refs['cell_edit_' + index +'_'+ field].$el.style.display = 'block'
        this.$refs['cell_edit_' + index +'_'+ field].$el.focus()
      }
    },
    changeCell: function (index, field) {
      this.$refs['cell_view_' + index +'_'+ field].style.display = 'block'
      if (this.$refs['cell_edit_' + index +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + index +'_'+ field].style.display = 'none'
      } else {
        this.$refs['cell_edit_' + index +'_'+ field].$el.style.display = 'none'
      }
      this.$store.commit('sites/googleRegion/EXIST_CHANGE', true)
      // add new row
      if (this.SEARCH_ENGINE_DATA.length == (index + 1)) {
        let buf = this.SEARCH_ENGINE_DATA.splice(0)
        buf.push({
          id: '--',
          name: '',
          regionCode: '',
          lang: '',
        })
        this.$store.commit('sites/googleRegion/SEARCH_ENGINE_DATA', buf)

        this.activeEdit.index = null
        this.activeEdit.field = null
      }
      this.$forceUpdate()
    },
    brandsChange: function (brands) {
      this.SEARCH_ENGINE_DATA[this.activeEdit.index][this.activeEdit.field] = brands
      this.changeCell(this.activeEdit.index, this.activeEdit.field)
    },
    removeRow: function (id) {
      let buf = this.SEARCH_ENGINE_DATA.filter((el) => {
        if (el.id == id) {
          this.$store.commit('sites/googleRegion/ADD_TO_DELETED_LIST', id)
        }

        return el.id != id
      })
      this.$store.commit('sites/googleRegion/SEARCH_ENGINE_DATA', buf)
      this.$store.commit('sites/googleRegion/EXIST_CHANGE', true)
    },
    save: function () {
      this.SAVE({th: this})
    },
    sortingChanged: function (ctx) {
      if (this.checkIsChange()) {
        return false
      }
      let buf = Object.assign({}, this.PARAMS)
      buf.sort = {
        dir: ctx.sortDesc ? 'desc' : 'asc',
        field: ctx.sortBy
      }
      this.$store.commit('sites/googleRegion/PARAMS', buf)
      this.GET_DATA({th: this})
    },
    search: function () {
      if (this.checkIsChange()) {
        return false
      }
      this.searchChange()
      this.GET_DATA({th: this})
    },
    searchChange: function () {
      let buf = Object.assign({}, this.PARAMS)
      buf.search = this.searchVal
      this.$store.commit('sites/googleRegion/CURRENT_PAGE', 1)
      this.$store.commit('sites/googleRegion/PARAMS', buf)
    },
    reset: function () {
      if (this.checkIsChange()) {
        return false
      }
      this.searchVal = ''
      this.searchChange()
      this.GET_DATA({th: this})
    },
    checkIsChange: function () {
      if (this.EXIST_CHANGE) {
        this.$bvModal.show('noSaveWarning')
        // this.$bvModal.show('infoMessage')
        return true
      }
      return false
    },
    changeIgnore: function () {
      this.$store.commit('sites/googleRegion/EXIST_CHANGE', false)
    },
    searchFocusOut: function () {

    }
  },
  computed: {
    ...mapGetters([
      'SEARCH_ENGINE_DATA',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'AMOUNT_PAGE',
      'SEARCH_ENGINE_LIST',
      'SELECTED_TYPE',
      'PARAMS',
      'EXIST_CHANGE',
    ]),
  },
  watch: {
    currentPage(newVal) {
      this.$store.commit('sites/googleRegion/CURRENT_PAGE', newVal)
    },
    type(newVal) {
      this.$store.commit('sites/googleRegion/SELECTED_TYPE', newVal)
    }
  },
  mounted() {
    this.currentPage = this.CURRENT_PAGE
    this.type = this.SELECTED_TYPE
  },
  created() {
    this.initPageSize()
    if (this.SEARCH_ENGINE_DATA.length == 0) {
      this.GET_DATA({th: this})
    }
  }
}
</script>

<style scoped>
.dictionary-type {
  width: 77px;
  float: right
}
.cell-cursor {
  cursor: cell
}
.t-cell {
  overflow: hidden;
  width: 100%;
  display: block;
}
.remove-button {
  float: left;
  height: 24px;
  line-height: 15px;
}
.save-but {
  float: right
}
.search-box {
  width: 375px;
  float: left
}
.edit-cell {
  height: 24px;
  line-height: 15px
}
</style>